import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { ITipoAccidenteModel } from 'src/app/models/interfaces/tipo-accidente/ITipoAccidenteModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { TipoAccidenteModel } from 'src/app/models/tipo-accidente/TipoAccidenteModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { TipoAccidenteService } from 'src/app/services/tipo-accidente/tipo-accidente.service';

@Component({
  templateUrl: './configuracion-tipo-accidente-editar.component.html',
  styleUrls: ['./configuracion-tipo-accidente-editar.component.css']
})
export class ConfiguracionTipoAccidenteEditarComponent implements OnInit {
  id: number = 0;
  model: ITipoAccidenteModel = new TipoAccidenteModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private serviceTipoAccidente: TipoAccidenteService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_MAESTRO).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.serviceTipoAccidente.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.serviceTipoAccidente.update(this.model).subscribe((data) => {
            this.alertDialogService.open("El tipo de empleado fue actualizado");
            this.router.navigate(['/configuracion', 'tipo-accidentes']);  
          });
        }
      });
    }
  }
}
